<template>
    <InputTypeAheadEvent
        :button-only="props.buttonOnly"
        @item-selected="eventClicked"
        :small="props.small"
        ref="typeahed"
    />
</template>
<script setup lang="ts">
import type { TypeAheadItem } from '@/objects/generated';
import InputTypeAheadEvent from '../Typeahead/General/InputTypeAheadEvent.vue';
import { useKeyboardListener } from '@/composeables';
import type { TypeAheadExpose } from '../Typeahead/TypeAheadExpose';
import { ref } from 'vue';
import { Router } from '@/objects/Router';

const props = withDefaults(
    defineProps<{
        /**
         * If the typeahead should only be a button
         * Will expand when clicked
         * @default false
         */
        buttonOnly?: boolean;

        /**
         * If the typeahead should be small
         * @default false
         */
        small?: boolean;
    }>(),
    {
        buttonOnly: false,
        small: false,
    },
);

const typeahead = ref<TypeAheadExpose | null>(null);

useKeyboardListener().addKeyboardShortcut({
    on: 'CTRL+K',
    action: () => {
        typeahead.value?.focus();
    },
});

/**
 * Is called when a item is clicked in the typeahead
 * @param item
 * @param request
 */
const eventClicked = (item: TypeAheadItem) => Router.NavigateTo({ eventID: item.ID }, 'dashboard');
</script>
